export enum IeDocument {
  O = 'O',
  S = 'S',
  N = 'N',
  I = 'I',
}

export enum IeUndeterminedValidity {
  MARKED = 'S',
  UNMARKED = 'N',
}

export enum IeStatus {
  NOT_PENDING = 'S',
  PENDING = 'P',
}

export interface Attachment {
  filename: string;
  filepath: string;
  nrSeqAttachment: number;
}

export interface WidthComponent {
  minimumSize: 3;
  maximumSize: 9;
  mediumSize: 4;
  fullSize: 12;
}
